export default "__VITE_ASSET__FcQfDikw__"